import { Component, Host, h, Element } from '@stencil/core';

export interface AhaHistoryListItem extends HTMLAhaHistoryListItemElement {}

/**
 * The "history item" element.
 *
 * Note that the width of the "bullet" area (the section on the left) can be adjusted by tweaking the value of a CSS variable `--aha-history-list-item--bullet-width` with any valid CSS unit value.
 *
 * Typically used inside an `<aha-history-list>` ("history list") element.
 * @slot bullet - Contents of the "bullet" on the left side of the history list item.
 * @slot default - Contents of the default slot.
 */
@Component({
  tag: 'aha-history-list-item',
  styleUrl: 'aha-history-list-item.css',
  shadow: true,
})
export class AhaHistoryListItem {
  @Element() host!: HTMLAhaHistoryListItemElement;
  render() {
    return (
      <Host role="listitem">
        <div id="top-line" class="line"></div>
        <div class="gap" id="top-gap"></div>
        <div id="bullet" part="bullet">
          <slot name="bullet">
            <div id="bullet-default" class="line"></div>
          </slot>
          <div id="bullet-line" class="line"></div>
        </div>
        <div id="content" part="content">
          <slot></slot>
        </div>
        <div id="bottom-line" class="line"></div>
        <div class="gap" id="bottom-gap"></div>
      </Host>
    );
  }
}
